import { type FilterCommonProps, MultiDropdownFilter } from '@carboncopyco/ui';
import type { DropdownFilterItemContent } from '@carboncopyco/ui';
import { useUrlState } from '../../utils';
import type { UrlState } from '../types';

type MultiStringFilterProps = {
  type: keyof UrlState;
  options: DropdownFilterItemContent<string>[];
} & Pick<FilterCommonProps, 'placeholder' | 'capsuleWidth' | 'contentWidth'>;

export const MultiStringFilter = ({
  options,
  type,
  ...rest
}: MultiStringFilterProps) => {
  const [urlState, setUrlState] = useUrlState<UrlState>({});
  const selectedOptions = urlState[type];

  return (
    <MultiDropdownFilter
      {...rest}
      selectedItems={
        selectedOptions
          ? Object.fromEntries(
              selectedOptions
                .split(',')
                .map((optionId) => [
                  optionId,
                  options.find((option) => option.id === optionId)?.label,
                ])
            )
          : {}
      }
      searchableGroup={{ items: options }}
      onChange={(optionId) => {
        const optionsSet = new Set(
          selectedOptions?.split(',').map((option) => option.trim())
        );
        if (optionsSet.has(optionId)) {
          optionsSet.delete(optionId);
        } else {
          optionsSet.add(optionId);
        }
        setUrlState({
          ...urlState,
          [type]: Array.from(optionsSet.values()).join(','),
        });
      }}
      onClear={() => setUrlState({ ...urlState, [type]: undefined })}
    />
  );
};
